export const EMAIL_COMMUNICATION_TYPE = Object.freeze({
  FRENCH: "fr",
  ENGLISH: "en",
  BILINGUAL: "bilingual",
});
